import { useEffect } from "react";

export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
      Redirecting...
    </div>
  );
}
